import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Identifying the Voice That Seeks Approval",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I don’t try to stop seeking approval. I notice when it happens."
    ],
      [
      "Daily intention: Today I don’t try to stop seeking approval. I notice when it happens."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One slow breath.",
      "In my heart: “This is the need for approval. It is not me.”"
    ],
      [
      "I pause with myself.",
      "One slow breath.",
      "In my heart: “This is the need for approval. It is not me.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. When today is it most important to me what others think of me?\n[Write here]",
      "2. What fear sits underneath this? (rejection / shame / not belonging)\n[Write here]",
      "3. Where do I feel this need in my body?\n[Write here]"
    ],
      [
      "1. When today is it most important to me what others think of me?\n[Write here]",
      "2. What fear sits underneath this? (rejection / shame / not belonging)\n[Write here]",
      "3. Where do I feel this need in my body?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Seeking approval is a protection mechanism, not a weakness."
    ],
      [
      "Closing",
      "Seeking approval is a protection mechanism, not a weakness."
    ]
    ),
    action: localizedGenderNode(
      "Once today: one breath + “I noticed the need, I didn’t act on it.”",
      "Once today: one breath + “I noticed the need, I didn’t act on it.”"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "Fact vs. Imagination (“What Will Really Happen?”)",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I separate fear from reality."
    ],
      [
      "Daily intention: Today I separate fear from reality."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What am I afraid people will say about me?\n[Write here]",
      "2. What evidence actually exists for this?\n[Write here]",
      "3. What is more likely to happen in reality?\n[Write here]"
    ],
      [
      "1. What am I afraid people will say about me?\n[Write here]",
      "2. What evidence actually exists for this?\n[Write here]",
      "3. What is more likely to happen in reality?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "The mind exaggerates to protect — not to be accurate."
    ],
      [
      "Closing",
      "The mind exaggerates to protect — not to be accurate."
    ]
    ),
    action: localizedGenderNode(
      "When “what will they think” arises — I ask: “Is there proof?”",
      "When “what will they think” arises — I ask: “Is there proof?”"
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "The Cost of Living for Approval",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I see what this costs me."
    ],
      [
      "Daily intention: Today I see what this costs me."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. Where do I behave differently to be liked?\n[Write here]",
      "2. What do I give up about myself when I do this?\n[Write here]",
      "3. How does my body feel after I “please”?\n[Write here]"
    ],
      [
      "1. Where do I behave differently to be liked?\n[Write here]",
      "2. What do I give up about myself when I do this?\n[Write here]",
      "3. How does my body feel after I “please”?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "External approval sometimes buys short relief — and costs identity."
    ],
      [
      "Closing",
      "External approval sometimes buys short relief — and costs identity."
    ]
    ),
    action: localizedGenderNode(
      "Once today I notice myself pleasing — without fixing it.",
      "Once today I notice myself pleasing — without fixing it."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Where This Began",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I identify the root, without blame."
    ],
      [
      "Daily intention: Today I identify the root, without blame."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. When did I first learn that I need approval to be okay?\n[Write here]",
      "2. Who taught me this — through words or behavior?\n[Write here]",
      "3. What did I need back then and didn’t receive?\n[Write here]"
    ],
      [
      "1. When did I first learn that I need approval to be okay?\n[Write here]",
      "2. Who taught me this — through words or behavior?\n[Write here]",
      "3. What did I need back then and didn’t receive?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "What was learned can also be relearned."
    ],
      [
      "Closing",
      "What was learned can also be relearned."
    ]
    ),
    action: localizedGenderNode(
      "One sentence to my younger self: “You didn’t need to prove yourself.”",
      "One sentence to my younger self: “You didn’t need to prove yourself.”"
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Noticing People-Pleasing in Real Time",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I slow down before saying “yes.”"
    ],
      [
      "Daily intention: Today I slow down before saying “yes.”"
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. Where is it hardest for me to say “no”?\n[Write here]",
      "2. What am I afraid will happen if I refuse?\n[Write here]",
      "3. What happens to me if I keep saying “yes” at my expense?\n[Write here]"
    ],
      [
      "1. Where is it hardest for me to say “no”?\n[Write here]",
      "2. What am I afraid will happen if I refuse?\n[Write here]",
      "3. What happens to me if I keep saying “yes” at my expense?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Before saying “yes” to others — there is a “yes” to myself."
    ],
      [
      "Closing",
      "Before saying “yes” to others — there is a “yes” to myself."
    ]
    ),
    action: localizedGenderNode(
      "Before answering: one breath + “What is right for me?”",
      "Before answering: one breath + “What is right for me?”"
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Approval vs. Real Connection",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I distinguish love from pleasing."
    ],
      [
      "Daily intention: Today I distinguish love from pleasing."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. With whom do I feel connection without impressing?\n[Write here]",
      "2. How does it feel in my body to simply be myself?\n[Write here]",
      "3. What does this teach me about relationships?\n[Write here]"
    ],
      [
      "1. With whom do I feel connection without impressing?\n[Write here]",
      "2. How does it feel in my body to simply be myself?\n[Write here]",
      "3. What does this teach me about relationships?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Real connection does not require performance."
    ],
      [
      "Closing",
      "Real connection does not require performance."
    ]
    ),
    action: localizedGenderNode(
      "I choose one person to simply be with.",
      "I choose one person to simply be with."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "A Small Experiment (Behavior)",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I do something small without checking reactions."
    ],
      [
      "Daily intention: Today I do something small without checking reactions."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. Which action do I avoid because of others’ opinions?\n[Write here]",
      "2. What is the 10% version of it?\n[Write here]",
      "3. What do I want to feel afterward?\n[Write here]"
    ],
      [
      "1. Which action do I avoid because of others’ opinions?\n[Write here]",
      "2. What is the 10% version of it?\n[Write here]",
      "3. What do I want to feel afterward?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing"
    ],
      [
      "Closing"
    ]
    ),
    action: localizedGenderNode(
      "Small action for today",
      "Small action for today"
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Allowing Discomfort (ACT)",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I stay with discomfort without running to approval."
    ],
      [
      "Daily intention: Today I stay with discomfort without running to approval."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What sensation arises when I don’t get approval?\n[Write here]",
      "2. One-minute practice: I let the sensation be. What happens?\n[Write here]",
      "3. What did I learn about the wave?\n[Write here]"
    ],
      [
      "1. What sensation arises when I don’t get approval?\n[Write here]",
      "2. One-minute practice: I let the sensation be. What happens?\n[Write here]",
      "3. What did I learn about the wave?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Discomfort is a wave — not danger."
    ],
      [
      "Closing",
      "Discomfort is a wave — not danger."
    ]
    ),
    action: localizedGenderNode(
      "One minute only. Consistency > force.",
      "One minute only. Consistency > force."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "The Inner Critic When Approval Is Missing",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I notice how the critic replaces external approval."
    ],
      [
      "Daily intention: Today I notice how the critic replaces external approval."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What does the critic say when approval is absent?\n[Write here]",
      "2. How would I speak to a close friend instead?\n[Write here]",
      "3. Which gentle sentence do I choose today?\n[Write here]"
    ],
      [
      "1. What does the critic say when approval is absent?\n[Write here]",
      "2. How would I speak to a close friend instead?\n[Write here]",
      "3. Which gentle sentence do I choose today?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "I don’t need to punish myself when others are silent."
    ],
      [
      "Closing",
      "I don’t need to punish myself when others are silent."
    ]
    ),
    action: localizedGenderNode(
      "When the critic appears — one gentle sentence only.",
      "When the critic appears — one gentle sentence only."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "A Boundary Against “What Will They Think”",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I set one inner boundary."
    ],
      [
      "Daily intention: Today I set one inner boundary."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. Where does “what will they think” control me most?\n[Write here]",
      "2. What small boundary am I willing to set this week?\n[Write here]",
      "3. What fear surrounds this boundary?\n[Write here]"
    ],
      [
      "1. Where does “what will they think” control me most?\n[Write here]",
      "2. What small boundary am I willing to set this week?\n[Write here]",
      "3. What fear surrounds this boundary?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "A boundary doesn’t push love away — it protects me."
    ],
      [
      "Closing",
      "A boundary doesn’t push love away — it protects me."
    ]
    ),
    action: localizedGenderNode(
      "One action that honors the boundary.",
      "One action that honors the boundary."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Self-Worth Without an Audience",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I ask who I am when no one is watching."
    ],
      [
      "Daily intention: Today I ask who I am when no one is watching."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What do I like about myself regardless of others’ opinions?\n[Write here]",
      "2. Where do I feel stable even alone?\n[Write here]",
      "3. How does that feel in my body?\n[Write here]"
    ],
      [
      "1. What do I like about myself regardless of others’ opinions?\n[Write here]",
      "2. Where do I feel stable even alone?\n[Write here]",
      "3. How does that feel in my body?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "My worth does not depend on spectators."
    ],
      [
      "Closing",
      "My worth does not depend on spectators."
    ]
    ),
    action: localizedGenderNode(
      "A short time alone — no posting, no sharing.",
      "A short time alone — no posting, no sharing."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Changing Inner Language",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I replace “they must approve” with “I choose myself.”"
    ],
      [
      "Daily intention: Today I replace “they must approve” with “I choose myself.”"
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. Which old belief controls me?\n[Write here]",
      "2. How does it sound in a gentler, healthier language?\n[Write here]",
      "3. Which sentence do I adopt for this week?\n[Write here]"
    ],
      [
      "1. Which old belief controls me?\n[Write here]",
      "2. How does it sound in a gentler, healthier language?\n[Write here]",
      "3. Which sentence do I adopt for this week?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Language creates reality."
    ],
      [
      "Closing",
      "Language creates reality."
    ]
    ),
    action: localizedGenderNode(
      "I use the new sentence once.",
      "I use the new sentence once."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Choosing an Inner Direction",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I define direction, not reaction."
    ],
      [
      "Daily intention: Today I define direction, not reaction."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. Which value matters more to me than approval?\n[Write here]",
      "2. How does it look in one small behavior?\n[Write here]",
      "3. What do I promise myself in moments of doubt?\n[Write here]"
    ],
      [
      "1. Which value matters more to me than approval?\n[Write here]",
      "2. How does it look in one small behavior?\n[Write here]",
      "3. What do I promise myself in moments of doubt?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "An inner direction is stronger than external noise."
    ],
      [
      "Closing",
      "An inner direction is stronger than external noise."
    ]
    ),
    action: localizedGenderNode(
      "I choose one action based on the value.",
      "I choose one action based on the value."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Gentle Closure",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I finish with loyalty to myself."
    ],
      [
      "Daily intention: Today I finish with loyalty to myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What changed in me during this journey?\n[Write here]",
      "2. What became clearer about approval?\n[Write here]",
      "3. A return sentence for difficult days:\n[Write here]"
    ],
      [
      "1. What changed in me during this journey?\n[Write here]",
      "2. What became clearer about approval?\n[Write here]",
      "3. A return sentence for difficult days:\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Final closure of the journey",
      "I can listen to others —",
      "without abandoning myself.",
      "I keep walking",
      "with my own voice.",
      "And that is strength."
    ],
      [
      "Final closure of the journey",
      "I can listen to others —",
      "without abandoning myself.",
      "I keep walking",
      "with my own voice.",
      "And that is strength."
    ]
    ),
    action: localizedGenderNode(
      "One action that symbolizes: “I am on my side.”",
      "One action that symbolizes: “I am on my side.”"
    ),
  },
].map(buildNormalizedDay);

export const dependenceOnExternalApprovalBlueprintEn = buildNormalizedPilotBlueprint({
  id: "dependence_on_external_approval_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "dependence_on_external_approval",
  category: "general",
  journeyName: {
    he: "תלות באישור מבחוץ",
    en: "Dependence on External Approval",
    es: "Dependencia de la Aprobación Externa",
  },
  days,
});

export default dependenceOnExternalApprovalBlueprintEn;
